import {QbParticipantPerson} from "./base"
import {DELETE, HEAD, PUT} from "@qb-assets-js/qb-fetch";

class QbUser extends QbParticipantPerson {
}
QbUser.register;

export class QbPlayer extends QbParticipantPerson {

    get init() {

        super.init;
        this.addEventListener("dragstart", this);
        this.draggable = true; //round_index >= 0;
    }


    handleEvent_dragstart(evt) {
        const round = document.documentElement.dataset.round,
            current_index = this.closest("[data-index]")?.dataset?.index;
        if(self.isMc && round === "-0/00" && /^-0|^\d/.test(current_index)) {
            evt.dataTransfer.setData(evt.target.dataset.slot_index, evt.target.dataset.slot_index);
            evt.dataTransfer.setData(evt.target.itemid, evt.target.itemid);
            evt.dataTransfer.effectAllowed = 'move';
        }
        else evt.preventDefault();
    }


    set teams(value) {
        const ariaLabel = _("Select a team");
        const node = this.parentNode.querySelector(':scope > nav > select[name="slot-select"]') ||
            SELECT({name: "slot-select",  events: [this, {change: "slot_select"}], ariaLabel});
        if(!node.isConnected) NAV({beforeend: this.parentNode}, node);
        node.replaceChildren(
            OPTION({disabled: true, selected: true, value: ""}, ariaLabel)
        );
        if(value.length) {
            OPTGROUP({label: "Your teams", beforeend: node}, value.map(v => {
                const disabled = false;
                return OPTION({itemid: v.itemid, disabled, value: `/player/${this.itemid}/slot/${v.itemid}`}, v.name);
            }));
        }
        OPTGROUP({label: "New team", beforeend: node},
            OPTION({value: `/player/${this.itemid}/slot/new`},
                _("Create"))
        );
    }



    // get defaults() {
    //     return {
    //         avatar: '😎',
    //         name: 'Unknown'
    //     };
    // }

    // get finalize() {
    //     this.staff = (this.itemid === self.userId);
    // }
    //
    //
    // get #slotNodes() {
    //     return [...this.parentElement.getElementsByTagName("qb-slot")].filter(n=>n.index !== this.index);
    // }
    //
    // handleEvent(evt) {
    //     switch(evt.type) {
    //         case "dragstart":
    //             evt.dataTransfer.effectAllowed = "move";
    //             this.addEventListener('dragend', this, {once: true});
    //             this.#slotNodes.forEach(n=>{
    //                 n.addEventListener('dragover', this);
    //                 n.addEventListener('drop', this);
    //                 n.addEventListener('dragenter', this);
    //                 n.addEventListener('dragleave', this);
    //             });
    //             return;
    //         case "dragover":
    //             evt.preventDefault();
    //             evt.dataTransfer.dropEffect = "move";
    //             return;
    //         case "drop":
    //             evt.preventDefault();
    //             const index = evt.target.index,
    //                 itemid = this.itemid;
    //             PUT(location.toString().replace(/\/moderate.*$/, `/${index}`), {body: {itemid}}).result({
    //                 "202": (d) => { this.index = index; }
    //             });
    //             return;
    //         case "dragenter":
    //             return evt.currentTarget.addClass("dragging");
    //         case "dragleave":
    //             return evt.currentTarget.removeClass("dragging");
    //         case "dragend":
    //             this.#slotNodes.forEach(n=>{
    //                 n.removeEventListener('dragover', this);
    //                 n.removeEventListener('drop', this);
    //                 n.removeEventListener('dragenter', this);
    //                 n.removeEventListener('dragleave', this);
    //             });
    //             return [...document.getElementsByClassName("dragging")].forEach(n=>n.removeClass("dragging"));
    //         default:
    //             super.handleEvent(evt);
    //
    //     }
    // }


    // get identifier() {
    //     return JSON.stringify({
    //         itemtype: "Player",
    //         itemid: this.itemid,
    //         show_id: this.show.itemid
    //     });
    // }
    //
    // get staffNodes() {
    //     super.staffNodes;
    //     this.querySelector("button.leave") || BUTTON({beforeend: this,
    //             class: "leave admin", aria: {label: "Leave quiz"}, events: [this, {click: "leaveQuiz"}]
    //         }
    //     );
    // }
    //
    // handleEvent_leaveQuiz(evt) {
    //     confirm(_("Do you want to leave the quiz?")) && DELETE(`${location}/player`);
    // }
}

QbPlayer.register;